/**
 * Custom icons drawn on Lucide's 24×24 stroke grid so they sit alongside the
 * stock set. Register with lucide's createIcons (vanilla, `data-lucide="oil-rig"`)
 * or wrap with createLucideIcon for React.
 */

type IconNode = [tag: 'path' | 'rect' | 'circle', attrs: Record<string, string>][];

/** Drilling derrick: crown block, tapered legs with X-bracing, ground line. */
export const OilRig: IconNode = [
    ['rect', { x: '10', y: '2', width: '4', height: '2', rx: '0.5' }],
    ['path', { d: 'M11 4 6.5 20' }],
    ['path', { d: 'M13 4 17.5 20' }],
    ['path', { d: 'M9.6 9h4.8' }],
    ['path', { d: 'M8.2 14h7.6' }],
    ['path', { d: 'm9.6 9 6.2 5' }],
    ['path', { d: 'm14.4 9-6.2 5' }],
    ['path', { d: 'M3 20h18' }],
];
